var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('registries',{ref:_vm.tableRef,attrs:{"fields":_vm.fields,"repository":_vm.repository,"resource":_vm.resource,"filterName":_vm.filterName,"onlyActions":['infomodal', 'edit'],"noInnerWidth":"","noInputPaginator":"","noPagination":""},on:{"edit":_vm.onEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }